/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFoldDown = createReactComponent("fold-down", "IconFoldDown", [
  ["path", { d: "M12 11v8l3 -3m-6 0l3 3", key: "svg-0" }],
  ["path", { d: "M9 7l1 0", key: "svg-1" }],
  ["path", { d: "M14 7l1 0", key: "svg-2" }],
  ["path", { d: "M19 7l1 0", key: "svg-3" }],
  ["path", { d: "M4 7l1 0", key: "svg-4" }]
]);

export { IconFoldDown as default };
//# sourceMappingURL=IconFoldDown.js.map
